import { render, staticRenderFns } from "./add-information.vue?vue&type=template&id=a2d084c4&scoped=true"
import script from "./add-information.vue?vue&type=script&lang=js"
export * from "./add-information.vue?vue&type=script&lang=js"
import style0 from "./add-information.vue?vue&type=style&index=0&id=a2d084c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d084c4",
  null
  
)

export default component.exports